import { http } from "./httpClient";

const qs = (o) =>
  Object.entries(o).filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&");

/** Independent Content Calendar (planning + tracking). Nothing here publishes to Instagram. */
export const calendarApi = {
  month: (accountId, start, end) => http.get(`/content-calendar/?${qs({ account_id: accountId, start, end })}`),
  plan: (id) => http.get(`/content-calendar/plans/${id}/`),
  create: (body) => http.post("/content-calendar/plans/", body),
  update: (id, body) => http.patch(`/content-calendar/plans/${id}/`, body),
  remove: (id) => http.delete(`/content-calendar/plans/${id}/`),
  schedulerJobs: (accountId) => http.get(`/content-calendar/scheduler-jobs/?${qs({ account_id: accountId })}`),
  check: (accountId) => http.post("/content-calendar/check/", { account_id: accountId }),
  confirm: (id, mediaId) => http.post(`/content-calendar/plans/${id}/confirm/`, { media_id: mediaId }),
  publications: (id, page = 1) => http.get(`/content-calendar/plans/${id}/publications/?page=${page}`),
};
